import { extend } from 'sk-ui/lib/utils/util.js'

import serverForm from './metaData/serverForm'

export default {
  serverCreate({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: serverForm,
      props
    })
  },
  serverEdit({ commit }, params) {
    const props = {
      title: '编辑用例',
      params: {
        id: params.rowIds[0]
      }
    }
    const editForm = extend(true, {}, serverForm)
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  }
}
